"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { key: 0 };
const _hoisted_2 = { class: "font-bold" };
const _hoisted_3 = { class: "mb-5" };
const _hoisted_4 = { class: "font-bold" };
const _hoisted_5 = { class: "mt-4 pt-4 border-t-1 border-gray flex justify-end" };
const _hoisted_6 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-check" }, null, -1);
const vue_3 = require("vue");
const TextareaInput_vue_1 = __importDefault(require("../../components/Form/TextareaInput.vue"));
const i18n_1 = require("../../common/i18n");
const toastStore_1 = require("../../stores/toast/toastStore");
const fetch_1 = __importDefault(require("../../common/utils/fetch"));
const vue_router_1 = require("vue-router");
exports.default = (0, vue_1.defineComponent)({
    __name: 'OrderNote',
    props: {
        openOrder: {
            type: Object,
        },
    },
    emits: ["saved"],
    setup(__props, { emit }) {
        const props = __props;
        const toastStore = (0, toastStore_1.useToastStore)();
        const router = (0, vue_router_1.useRouter)();
        const note = (0, vue_3.ref)(undefined);
        const orderNoteId = (0, vue_3.ref)(null);
        const getOrderNote = async () => {
            var _a;
            if (!((_a = props.openOrder) === null || _a === void 0 ? void 0 : _a.id))
                return;
            try {
                const url = router.resolve({ name: "admin_order_notes_api", params: { orderId: props.openOrder.id } }).href;
                const response = await (0, fetch_1.default)(url);
                if (response["@type"] === "OrderNote") {
                    note.value = response.note;
                    orderNoteId.value = response.id;
                }
            }
            catch (error) {
                toastStore.addErrorToast(error.toString());
            }
        };
        const saveOrderNote = async () => {
            var _a;
            if (!note.value || !((_a = props.openOrder) === null || _a === void 0 ? void 0 : _a.id))
                return;
            let method;
            let route;
            let body;
            if (orderNoteId.value) {
                // Szerkesztés.
                method = "PUT";
                route = router.resolve({ name: "admin_order_notes_api", params: { orderId: orderNoteId.value } });
                body = { note: note.value };
            }
            else {
                // Létrehozás.
                method = "POST";
                route = router.resolve({ name: "admin_order_notes_api" });
                body = { orderId: props.openOrder.id, note: note.value };
            }
            try {
                await (0, fetch_1.default)(route.href, { method, body: JSON.stringify(body) });
                emit("saved");
                toastStore.addToast({
                    message: (0, i18n_1.trans)("order_note_created_successfully", "Order note created successfully!", "order_note"),
                    type: "success",
                    timer: 5,
                });
            }
            catch (error) {
                toastStore.addErrorToast(error.toString());
            }
        };
        (0, vue_3.onBeforeMount)(() => {
            getOrderNote();
        });
        return (_ctx, _cache) => {
            return (__props.openOrder !== undefined)
                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                    (0, vue_2.createElementVNode)("div", null, [
                        (0, vue_2.createElementVNode)("span", _hoisted_2, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("order_id", "Order ID", "order_note")) + ":", 1),
                        (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)(__props.openOrder.id), 1)
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_3, [
                        (0, vue_2.createElementVNode)("span", _hoisted_4, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("delivery_address", "Delivery Address", "order_note")) + ":", 1),
                        (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)(__props.openOrder.shippingName) + " " + (0, vue_2.toDisplayString)(__props.openOrder.shippingZip) + " " + (0, vue_2.toDisplayString)(__props.openOrder.shippingCity) + ", " + (0, vue_2.toDisplayString)(__props.openOrder.shippingStreet), 1)
                    ]),
                    (0, vue_2.createVNode)(TextareaInput_vue_1.default, {
                        modelValue: note.value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((note).value = $event)),
                        label: (0, vue_2.unref)(i18n_1.trans)('note', 'Note', 'order_note'),
                        class: "my-5",
                        border: ""
                    }, null, 8, ["modelValue", "label"]),
                    (0, vue_2.createElementVNode)("div", _hoisted_5, [
                        (0, vue_2.createElementVNode)("button", {
                            class: "btn btn-rounded btn-primary",
                            onClick: _cache[1] || (_cache[1] = ($event) => (saveOrderNote()))
                        }, [
                            _hoisted_6,
                            (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("save", "Save", "order_note")), 1)
                        ])
                    ])
                ]))
                : (0, vue_2.createCommentVNode)("", true);
        };
    }
});
